import apiFetch from '../../apiFetch'

export default function (limpiezaSilosAnadidas, token) {
  return apiFetch({endPoint: `Bioseguridad/getSilos`, method: 'POST', body: limpiezaSilosAnadidas, token: token})
}
